// extracted by mini-css-extract-plugin
export default {"whole-container":"policyPage_whole-container__r7MSY"};